import React from 'react';
import { useFloorPlan } from '../FloorPlanContext';

const UnitSwitch: React.FC = () => {
  const { unitSystem, setUnitSystem } = useFloorPlan();
  const isMobile = window.innerWidth <= 700;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: isMobile ? 'auto' : '30px',
        top: isMobile ? '30px' : 'auto',  // Moved up from 40px to 35px
        left: isMobile ? '50%' : '30px',
        transform: isMobile ? 'translateX(-50%) scale(0.75, 0.9)' : 'none',  // Different X and Y scale - less width (0.75), more height (0.9)
        zIndex: 1000,
        display: 'flex',
        border: '1px solid #333',
        borderRadius: '8px',
        overflow: 'hidden',
        backgroundColor: '#fff',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        userSelect: 'none',
        WebkitUserSelect: 'none',
        MozUserSelect: 'none',
        msUserSelect: 'none',
      }}
    >
      <button
        onClick={() => setUnitSystem('imperial')}
        style={{
          padding: isMobile ? '8px 10px' : '8px 16px',  // More vertical padding, less horizontal
          border: 'none',
          backgroundColor: unitSystem === 'imperial' ? '#000' : '#fff',
          color: unitSystem === 'imperial' ? '#fff' : '#333',
          cursor: 'pointer',
          fontSize: isMobile ? '11px' : '13px',
          fontWeight: unitSystem === 'imperial' ? '600' : '400',
          transition: 'all 0.2s',
          maxWidth: isMobile ? '45px' : '60px',  // Reduced width further
        }}
      >
        ft/in
      </button>
      <button
        onClick={() => setUnitSystem('metric')}
        style={{
          padding: isMobile ? '8px 10px' : '8px 16px',  // More vertical padding, less horizontal
          border: 'none',
          borderLeft: '1px solid #ddd',
          backgroundColor: unitSystem === 'metric' ? '#000' : '#fff',
          color: unitSystem === 'metric' ? '#fff' : '#333',
          cursor: 'pointer',
          fontSize: isMobile ? '11px' : '13px',
          fontWeight: unitSystem === 'metric' ? '600' : '400',
          transition: 'all 0.2s',
          minWidth: isMobile ? '45px' : '60px',  // Reduced width further
        }}
      >
        m/cm
      </button>
    </div>
  );
};

export default UnitSwitch;